import { convertFile, File, Id, RepositoryResponse } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useChatGroupRecentFiles(
  conversationId: Id,
  limit?: number,
  enabled?: boolean
) {
  const { server } = useServer()
  return useQuery<File[]>({
    queryKey: keys.recent(conversationId, limit),
    queryFn: fetchChatGroupRecentFiles,
    enabled: enabled && !!conversationId,
  })

  async function fetchChatGroupRecentFiles(): Promise<File[]> {
    let url = `/v2/chat/repository/${conversationId}/recent`
    if (limit) {
      url += `?limit=${limit}`
    }
    const response = await server.get<RepositoryResponse.File[]>(url)
    return response.map(convertFile)
  }
}
